import "./loader.scss";

import { Image, Modal } from "react-bootstrap";
import { LoaderGif } from "src/assets";
import { LoaderProps, typedMemo } from "src/types";

export const Loader = typedMemo(({ overlay }: LoaderProps) => {
  return overlay ? (
    <Modal centered show={overlay} animation={false} className="loader-modal">
      <Image src={LoaderGif} className="loader"/>
    </Modal>
  ) : (
    <Image src={LoaderGif} className="loader" />
  );
});
